module.exports = __webpack_public_path__ + "3bd21d9e61a06bffbed3c435f65c6f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/assets/becca.jpg
// module id = 1042
// module chunks = 0